<template>
  <div></div>
</template>

<script>
export default {
  emits: ['mounted'],
  beforeMount () {
    if (!this.captchaKey) return

    const script = document.createElement('script');
    script.src = `https://www.google.com/recaptcha/enterprise.js?render=${this.captchaKey}`;
    script.async = true;
    script.defer = true;
    script.id = this.captchaKey;
    script.onload = () => this.$emit('mounted');

    document.head.appendChild(script);
  },
  beforeDestroy () {
    if (!this.captchaKey) return

    document.getElementById(this.captchaKey).remove();

    const badges = document.getElementsByClassName('grecaptcha-badge')
    Array.from(badges).forEach(item => item.remove());
  },
  computed: {
    captchaKey () { return process.env.VUE_APP_RECAPTCHA_SITE_KEY }
  },
  methods: {
    execute () { 
      return new Promise(resolve => { 
        if (!this.captchaKey) resolve('') 
        
        const interval = setInterval(() => { 
          try {
            grecaptcha.enterprise.ready(async () => { 
              resolve(grecaptcha.enterprise.execute(this.captchaKey)); 
            })
            clearInterval(interval) 
          } catch (error) { }
          }, 200) 
      })
    }
  }
};
</script>
